export const commandList = {
  FETCH_SUGGESTIONS: 'fetch_suggestions',
  GO_HOME_PANEL: 'go_home_panel',
  GO_SEARCH_PANEL: 'go_search_panel',
  OPEN_BROWSER_WINDOW: 'open_browser_window',
  PICK_OPTION_MENU: 'pick_option_menu',
  REQUEST_TOP_SITES: 'request_top_sites',
  REMOTE_UI_IS_READY: 'remote_ui_is_ready',
  POST_TOP_SITES: 'post_top_sites',
};
